export const NAV_ITEMS = [
  { path: "/dashboard", label: "Dashboard", meta: "01", roles: ["lavoratore"] },
  { path: "/brand", label: "Brand e Clienti", meta: "02", roles: ["lavoratore"] },
  { path: "/calendario", label: "Calendario", meta: "03", roles: ["lavoratore", "cliente"] },
  { path: "/task", label: "Task", meta: "04", roles: ["lavoratore"] },
  { path: "/ped", label: "PED", meta: "05", roles: ["lavoratore"] },
  { path: "/report", label: "Report e Strategia", meta: "06", roles: ["lavoratore"] },
  { path: "/trend", label: "Ricerca Trend", meta: "07", roles: ["lavoratore"] },
  { path: "/impostazioni", label: "Impostazioni", meta: "08", roles: ["lavoratore", "cliente"] },
];

export const PHASES = [
  { n: 1, label: "Da preparare", color: "#9CA3AF", pct: 20 },
  { n: 2, label: "In lavorazione", color: "#3B82F6", pct: 40 },
  { n: 3, label: "Pronta per approvazione", color: "#F59E0B", pct: 60 },
  { n: 4, label: "Approvata", color: "#8B5CF6", pct: 80 },
  { n: 5, label: "Pubblicata", color: "#22C55E", pct: 100 },
];

export const FORMATS = ["Post", "Carosello", "Reel", "Storia", "Articolo blog", "Newsletter", "Altro"];

export const FONT_ROLES = ["Titolo", "Sottotitolo", "Corpo testo", "Didascalia"];

export const SOURCE_LEVELS = [
  { key: "ufficiale", label: "Fonte ufficiale", cls: "bg-emerald-700 text-white" },
  { key: "settore", label: "Fonte di settore", cls: "bg-blue-700 text-white" },
  { key: "non_verificata", label: "Opinione non verificata", cls: "bg-stone2e text-white" },
];

export const SOCIAL_PLATFORMS = ["Instagram", "Facebook", "TikTok", "LinkedIn", "YouTube", "Pinterest", "X", "Altro"];
